import React, { HTMLAttributes } from 'react';
import clsx from 'clsx';
import { createLayout } from '@clover-util/layout';

import styles from './ThreePartLayout.module.scss';

export const ThreePartLayout = createLayout<
  HTMLAttributes<HTMLElement>,
  'Main' | 'Footer' | 'Header'
>(function ThreePartLayout({ className, ...props }, useRegionRef) {
  return (
    <div className={clsx(styles.layout, className)} {...props} data-testid={'three-part-layout'}>
      <div ref={useRegionRef('Header')} className={styles.header} />
      <div ref={useRegionRef('Main')} className={styles.main} />
      <div ref={useRegionRef('Footer')} className={styles.footer} />
    </div>
  );
});
